<template>
  <v-flex class="pl-2 pr-2 pb-2">
    <v-layout align-start justify-start row class="mb-4">
      <v-icon color="primary" style="font-size: 50px">group</v-icon>
      <h2 :style="`color: ${$vuetify.theme.primary}`" class="mt-2">
        {{ $translate("CUSTOMERS") }}
      </h2>

    </v-layout>
    <v-text-field
      v-model="searchUser"
      append-icon="search"
      :label="$translate('SEARCH')"
      single-line
      hide-details
    ></v-text-field>
    <v-data-table
      :headers="headers"
      :items="users"
      class="elevation-1"
      :rows-per-page-items="[5]"
      :search="searchUser"
    >
      <template v-slot:items="props">
        <td>{{ props.item.email }}</td>
        <td>{{getUserState(props.item.state)}}</td>
        <td v-if="!partnerIsActive">{{ props.item.id }}</td>
        <td>{{ getUserRoles(props.item) }}</td>
        <td class="justify-center">
          <v-btn
            v-if="activePartner >= 6 && activePartner <= 9"
            small
            :disabled="props.item.editable"
            class="v-btn-tiny mr-2"
            color="primary"
            @click="editItem(props.item)"
          >
            <v-icon small>edit</v-icon>
          </v-btn>

          <v-btn
            v-if="activePartner >= 6 && activePartner <= 9"
            small
            :disabled="props.item.deletable"
            class="v-btn-tiny mr-2"
            color="primary"
            @click="deleteItem(props.item)"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning"
          >{{ $translate("SEARCH_FAILED_FIRST_PART") }} "{{ searchUser }}"
          {{ $translate("SEARCH_FAILED_SECOND_PART") }}</v-alert
        >
      </template>
    </v-data-table>
    <UserGroupDialog
      :showDialog="showUserGroupDialog"
      :id="editedItem.id"
      v-on:signalFromComponent="checkSignalFromComponent"
    />

    <v-dialog v-model="deleteDialog" persistent max-width="290" hide-overlay>
      <v-card>
        <v-progress-linear
          v-if="deleteDisableButton"
          :indeterminate="true"
          color="blue"
        ></v-progress-linear>
        <v-card-title class="headline">{{
          $translate("DELETE_USER")
        }}</v-card-title>
        <v-card-text
          >{{ $translate("ACCOUNT_DELETE_USER") }}:
          <b>{{ this.itemToBeDeleted.email }}</b> ?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" round @click.native="deleteDialog = false">{{
            $translate("CANCEL")
          }}</v-btn>
          <v-btn
            color="primary"
            :disabled="deleteDisableButton"
            round
            @click.native="deleteUserInUserGroup"
            >{{ $translate("DELETE") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import ImageLoader from "@/components/media/ImageLoader";
import AudioLoader from "@/components/media/AudioLoader";
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../../config/app_config";
import BaseObject from "@/objects/BaseObject";
import { Sketch } from "vue-color";
import _ from "lodash";
import { mapGetters } from "vuex";
import BaseComponent from "../base/BaseComponent";
import UserGroupDialog from "@/components/UserGroupDialog";
import { setTimeout } from "timers";

export default {
  extends: BaseComponent,
  name: "AccountUsers",
  components: {
    UserGroupDialog,
  },
  data() {
    return {
      activePartner: this.$store.getters["auth/userLevel"],
      showUserGroupDialog: false,
      searchUser: "",
      users: [],
      editedItem: {},
      editedIndex: -1,
      dialog: false,
      roles: [],
      deleteDisableButton: false,
      deleteDialog: false,
      showProgress: false,
      itemToBeDeleted: {},
      colors: "",
      partnerIsActive: false,

      defaultItem: {
        description: "",
        type: "Specific",
      },
      headers: [
        {
          text: this.$translate("EMAIL"),
          align: "left",
          sortable: true,
          value: "email",
        },
        {
          text: this.$translate('ACCOUNT_USER_STATE'),
          align: "left",
          sortable: true,
          value: "",
        },
        {
          text: this.$translate("ACCOUNT_USER_ID"),
          align: "left",
          sortable: true,
          value: "name",
        },
        {
          text: this.$translate("ACCOUNT_USER_ROLE_DESCRIPTION"),
          align: "left",
          sortable: false,
          value: "",
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "",
        },
      ],
    };
  },
  mounted() {
    this.checkIfUserIsPartner();
    this.getUsersForAccountWithDetails();
  },
  beforeDestroy() {},
  methods: {
    getUserState(state) {
      switch (Number(state)) {
        case -1:
          return this.$translate('USER_UNKNOWN');
        case 1:
          return this.$translate('USER_STATE_1');
        case 2:
          return this.$translate('USER_STATE_2');
        case 3:
          return this.$translate('USER_STATE_3');
        case 4:
          return this.$translate('USER_STATE_4');
        case 5:
          return this.$translate('USER_STATE_5');
        case 6:
          return this.$translate('USER_STATE_6');
      }
    },
    checkIfUserIsPartner() {
      if (
        this.$store.getters["auth/userLevel"] == 6 &&
        this.$store.getters["auth/partnerId"] !== -1
      ) {
        this.partnerIsActive = true;
        this.headers.splice(1, 1);
      }
    },
    checkSignalFromComponent(data) {
      if (data.closeDialog != undefined)
        this.showUserGroupDialog = !data.closeDialog;
      if (data.reload != undefined && data.reload == true)
        this.getUsersForAccountWithDetails();
    },
    deleteUserInUserGroup() {
      this.deleteDisableButton = true;
      const payload = {
        SelectedUserId: this.itemToBeDeleted.id,
        PartnerId: this.$store.getters["auth/partnerId"],
      };

      dssRequest.doRequest(
        (response) => {
          console.log("The generic call deleteUser was successful", response);
          setTimeout(() => {
            this.getUsersForAccountWithDetails();
            this.deleteDialog = false;
            this.deleteDisableButton = false;
          }, 1000);
        },
        (error) => {
          console.log("The generic call deleteUser was not successful", error);
          this.deleteDisableButton = false;
        },
        "deleteUser",
        this.$store.getters.getCurrentAccountId,
        payload
      );
    },
    editItem(item) {
      this.editedItem.id = item.id;
      this.$nextTick(() => {
        this.showUserGroupDialog = true;
      });
    },
    deleteItem(item) {
      this.itemToBeDeleted = item;
      this.deleteDialog = true;
    },
    getUserRoles(item) {
      let s = "";
      for (let [k, v] of Object.entries(item.userGroup)) {
        if (v.selected === "yes") s += ", " + v.description;
      }

      if (s.charAt(0) == "," || s.charAt(1) == ",") {
        s = s.substr(2);
      }
      return s;
    },
    getUsersForAccountWithDetails() {
      const payload = {
        FunctionId: "UserFunctionLibrary::getUsersForAccountWithDetails",
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The gerenic call getUsersForAccountWithDetails was successful",
            response
          );
          delete response.data.ErrorMsg;
          this.users = [];
          for (let [k, v] of Object.entries(response.data)) {
            v = BaseObject._toLowerCaseObjectProperties(v);
            if (this.$store.getters["auth/userLevel" > 6]) {
              if (
                Object.entries(v.userGroup)
                  .flatMap((e) => e[1])
                  .filter(
                    (t) =>
                      t.description == "Administrator" && t.selected == "yes"
                  ).length > 0
              ) {
                v.editable = false;
                v.deletable = true;
              } else {
                v.editable = false;
                v.deletable = false;
              }
            } else if (this.partnerIsActive) {
              for (let [key, value] of Object.entries(v.userGroup)) {
                value.tagId = key;
              }
              let checkConditions = Object.entries(v.userGroup).flatMap(
                (e) => e[1]
              );

              checkConditions.forEach((tag, index) => {
                if (
                  tag.description == "Administrator" &&
                  tag.selected == "yes"
                ) {
                  v.editable = true;
                  v.deletable = true;
                } else if (
                  tag.description == "Administrator" &&
                  tag.selected == "no" &&
                  tag.description == "Member" &&
                  tag.selected == "yes"
                ) {
                  v.editable = false;
                  v.deletable = false;
                }
                if (
                  tag.tagId == this.$store.getters["auth/partnerId"] &&
                  tag.selected == "yes"
                ) {
                  this.users.push({ id: k, ...v });
                }
              });
            } else {
              this.users.push({ id: k, ...v });
            }
          }
        },
        (error) => {
          console.log(
            "The generic call getUsersForAccountWithDetails was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        this.currentAccountId,
        payload
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  td {
    text-align: start;
  }
</style>
